// Never PDF — rejected with a permanent 422 on both report endpoints, not
// a placeholder for a future format. CSV/Excel are the only two options
// that ever belong in this dropdown.
export const REPORT_FORMATS = [
  { value: 'csv', label: 'CSV' },
  { value: 'xlsx', label: 'Excel' },
];

// Every report type the backend actually implements. `kyc` is admin-only —
// the investor endpoint 422s on it, but reportTypesForScope() filters it
// out client-side too, so the investor dropdown never even offers a way to
// trigger that failure.
export const REPORT_TYPES = [
  { value: 'investments', label: 'Investment performance', adminOnly: false },
  { value: 'transactions', label: 'Transactions and payouts', adminOnly: false },
  { value: 'support_tickets', label: 'Support tickets', adminOnly: false },
  { value: 'kyc', label: 'KYC submissions', adminOnly: true },
];

export function reportTypesForScope(scope) {
  return REPORT_TYPES.filter((t) => scope === 'admin' || !t.adminOnly);
}

export function reportTypeLabel(value) {
  return REPORT_TYPES.find((t) => t.value === value)?.label || value;
}

// Nicety only — the 422 from the server is still the real authority on
// this, this just saves an obviously-doomed round trip.
export function validateReportDateRange(dateFrom, dateTo) {
  if (!dateFrom || !dateTo) return null;
  if (new Date(dateTo) < new Date(dateFrom)) return '"To" date must be on or after "From" date.';
  return null;
}
